'use client'

import { FC, PropsWithChildren } from 'react'
import { BackButtonMobile } from '@components/shared/back-button/BackButton'
import {
  PageLayoutProvider,
  usePageLayoutContext,
} from '@layouts/page/context/PageLayout.context'
import { Header } from '@layouts/shared/header/Header'
import { Footer } from '@layouts/shared/footer/Footer'
import { MarketplaceProviders } from '@layouts/shared/MarketplaceProviders'
import { usePathname } from 'next/navigation'

export default function PageLayout({ children }: PropsWithChildren) {
  return (
    <PageLayoutProvider>
      <Content>{children}</Content>
    </PageLayoutProvider>
  )
}

const Content: FC<PropsWithChildren> = ({ children }) => {
  const { title } = usePageLayoutContext()
  const pathname = usePathname()
  // b2b page uses iframe in a whole screen
  const whitelistPages = ['/b2b']

  return (
    <MarketplaceProviders>
      <div className="relative flex min-h-screen flex-1 flex-col items-stretch">
        <div className="bg-gradient-image z-[-1] h-screen"></div>
        <div className="mt-20 flex flex-1 flex-col sm:mt-22 sm:mb-0 mb-[55px] min-h-screen">
          <Header />
          <main
            id="main-content"
            className={whitelistPages.includes(pathname) ? '' : 'mb-6 min-h-screen'}
          >
            <BackButtonMobile />
            {title && (
              <div className="xs:hidden container mx-auto px-4 py-6">
                <h1 className="text-h3 font-funnel text-cw-midnight-purple">{title}</h1>
              </div>
            )}
            {children}
          </main>
          <Footer />
        </div>
      </div>
    </MarketplaceProviders>
  )
}
